// @ts-check
import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Typography } from '@material-ui/core';
import { displayGiftCard, formatNumberToUSD } from 'utils';

const ReceiptGiftCardField = ({ classes, giftCard, isNewStyle }) => {
  const { giftCardBalance, selectedBalance, giftCardNumber } = giftCard;
  // If we have selectedBalance then show it.
  const displayedBalance = selectedBalance || giftCardBalance;

  return (
    <Grid container justifyContent="space-between" key={giftCardNumber}>
      <Typography
        className={isNewStyle ? classes.paymentLabel : null}
        variant="body2"
        color="textSecondary"
        gutterBottom
      >
        {displayGiftCard(giftCard)}
      </Typography>
      <Typography variant="body2" color="textPrimary" gutterBottom className={isNewStyle ? classes.paymentValue : null}>
        -{formatNumberToUSD(displayedBalance)}
      </Typography>
    </Grid>
  );
};

ReceiptGiftCardField.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  isNewStyle: PropTypes.bool,
};

ReceiptGiftCardField.defaultProps = {
  classes: {},
  isNewStyle: false,
};

export default ReceiptGiftCardField;
